import Text from "common/Typography/Text.tsx";
import styled from "styled-components";

interface ListDescriptionProps {
  texts: string[];
}

const ListDescription = ({ texts }: ListDescriptionProps) => {
  return (
    <StyledText as="div">
      <StyledUl>
        {texts.map((text, index) => (
          <li key={index}>{text}</li>
        ))}
      </StyledUl>
    </StyledText>
  );
};

export default ListDescription;

const StyledText = styled(Text)`
  margin-bottom: 24px;
`;
const StyledUl = styled.ul`
  padding-inline-start: 18px;
  margin: 0;
  padding-block-start: 4px;
`;
